__turbopack_context__.v({
  "accountBtn": "Sidebar-module__naTdSG__accountBtn",
  "accountBtnCollapsed": "Sidebar-module__naTdSG__accountBtnCollapsed",
  "accountBtnOpen": "Sidebar-module__naTdSG__accountBtnOpen",
  "accountChevron": "Sidebar-module__naTdSG__accountChevron",
  "accountId": "Sidebar-module__naTdSG__accountId",
  "accountMeta": "Sidebar-module__naTdSG__accountMeta",
  "accountName": "Sidebar-module__naTdSG__accountName",
  "accountRole": "Sidebar-module__naTdSG__accountRole",
  "accountRow": "Sidebar-module__naTdSG__accountRow",
  "accountText": "Sidebar-module__naTdSG__accountText",
  "avatar": "Sidebar-module__naTdSG__avatar",
  "avatarWrap": "Sidebar-module__naTdSG__avatarWrap",
  "brand": "Sidebar-module__naTdSG__brand",
  "brandCollapsed": "Sidebar-module__naTdSG__brandCollapsed",
  "brandMark": "Sidebar-module__naTdSG__brandMark",
  "brandMeta": "Sidebar-module__naTdSG__brandMeta",
  "brandName": "Sidebar-module__naTdSG__brandName",
  "brandStack": "Sidebar-module__naTdSG__brandStack",
  "collapsed": "Sidebar-module__naTdSG__collapsed",
  "collapsedAvatarBtn": "Sidebar-module__naTdSG__collapsedAvatarBtn",
  "deskPulseRing": "Sidebar-module__naTdSG__deskPulseRing",
  "dock": "Sidebar-module__naTdSG__dock",
  "dockBtn": "Sidebar-module__naTdSG__dockBtn",
  "dockCollapsed": "Sidebar-module__naTdSG__dockCollapsed",
  "dockLabel": "Sidebar-module__naTdSG__dockLabel",
  "dockRow": "Sidebar-module__naTdSG__dockRow",
  "footer": "Sidebar-module__naTdSG__footer",
  "footerCollapsed": "Sidebar-module__naTdSG__footerCollapsed",
  "header": "Sidebar-module__naTdSG__header",
  "headerCollapsed": "Sidebar-module__naTdSG__headerCollapsed",
  "headerInner": "Sidebar-module__naTdSG__headerInner",
  "menuAction": "Sidebar-module__naTdSG__menuAction",
  "nt-r26-none": "Sidebar-module__naTdSG__nt-r26-none",
  "pulse": "Sidebar-module__naTdSG__pulse",
  "pulseBrand": "Sidebar-module__naTdSG__pulseBrand",
  "pulseBrandText": "Sidebar-module__naTdSG__pulseBrandText",
  "pulseCollapsed": "Sidebar-module__naTdSG__pulseCollapsed",
  "pulseCollapsedBtn": "Sidebar-module__naTdSG__pulseCollapsedBtn",
  "pulseCompact": "Sidebar-module__naTdSG__pulseCompact",
  "pulseEdit": "Sidebar-module__naTdSG__pulseEdit",
  "pulseHeader": "Sidebar-module__naTdSG__pulseHeader",
  "pulseHeaderActions": "Sidebar-module__naTdSG__pulseHeaderActions",
  "pulseMark": "Sidebar-module__naTdSG__pulseMark",
  "pulseMarkCore": "Sidebar-module__naTdSG__pulseMarkCore",
  "pulseMarkLive": "Sidebar-module__naTdSG__pulseMarkLive",
  "pulseMarkRing": "Sidebar-module__naTdSG__pulseMarkRing",
  "pulseSlots": "Sidebar-module__naTdSG__pulseSlots",
  "pulseStack": "Sidebar-module__naTdSG__pulseStack",
  "pulseTag": "Sidebar-module__naTdSG__pulseTag",
  "pulseTitle": "Sidebar-module__naTdSG__pulseTitle",
  "quickActionBtn": "Sidebar-module__naTdSG__quickActionBtn",
  "quickActions": "Sidebar-module__naTdSG__quickActions",
  "quickActionsGrid": "Sidebar-module__naTdSG__quickActionsGrid",
  "quickActionsLabel": "Sidebar-module__naTdSG__quickActionsLabel",
  "quickBtn": "Sidebar-module__naTdSG__quickBtn",
  "railBody": "Sidebar-module__naTdSG__railBody",
  "railCapital": "Sidebar-module__naTdSG__railCapital",
  "railIcon": "Sidebar-module__naTdSG__railIcon",
  "railItem": "Sidebar-module__naTdSG__railItem",
  "railKbd": "Sidebar-module__naTdSG__railKbd",
  "railLabel": "Sidebar-module__naTdSG__railLabel",
  "railLink": "Sidebar-module__naTdSG__railLink",
  "railLinkActive": "Sidebar-module__naTdSG__railLinkActive",
  "railList": "Sidebar-module__naTdSG__railList",
  "railMain": "Sidebar-module__naTdSG__railMain",
  "railNav": "Sidebar-module__naTdSG__railNav",
  "railNight": "Sidebar-module__naTdSG__railNight",
  "railSection": "Sidebar-module__naTdSG__railSection",
  "root": "Sidebar-module__naTdSG__root",
  "scroll": "Sidebar-module__naTdSG__scroll",
  "sectionTitle": "Sidebar-module__naTdSG__sectionTitle",
  "shortcutBay": "Sidebar-module__naTdSG__shortcutBay",
  "statusDot": "Sidebar-module__naTdSG__statusDot",
  "toggle": "Sidebar-module__naTdSG__toggle",
  "toggleCollapsed": "Sidebar-module__naTdSG__toggleCollapsed",
  "userMenu": "Sidebar-module__naTdSG__userMenu",
  "userMenuActions": "Sidebar-module__naTdSG__userMenuActions",
  "userMenuHeader": "Sidebar-module__naTdSG__userMenuHeader",
  "userMenuName": "Sidebar-module__naTdSG__userMenuName",
  "userMenuRole": "Sidebar-module__naTdSG__userMenuRole",
  "userMenuStatus": "Sidebar-module__naTdSG__userMenuStatus",
  "userMenuStatusDot": "Sidebar-module__naTdSG__userMenuStatusDot",
  "watchAsk": "Sidebar-module__naTdSG__watchAsk",
  "watchBid": "Sidebar-module__naTdSG__watchBid",
  "watchChg": "Sidebar-module__naTdSG__watchChg",
  "watchCollapsedBtn": "Sidebar-module__naTdSG__watchCollapsedBtn",
  "watchCols": "Sidebar-module__naTdSG__watchCols",
  "watchColsChg": "Sidebar-module__naTdSG__watchColsChg",
  "watchDown": "Sidebar-module__naTdSG__watchDown",
  "watchEmpty": "Sidebar-module__naTdSG__watchEmpty",
  "watchLast": "Sidebar-module__naTdSG__watchLast",
  "watchPickChg": "Sidebar-module__naTdSG__watchPickChg",
  "watchPickLast": "Sidebar-module__naTdSG__watchPickLast",
  "watchPickLastEmpty": "Sidebar-module__naTdSG__watchPickLastEmpty",
  "watchPickPip": "Sidebar-module__naTdSG__watchPickPip",
  "watchPickPipOn": "Sidebar-module__naTdSG__watchPickPipOn",
  "watchPickRow": "Sidebar-module__naTdSG__watchPickRow",
  "watchPickRowOn": "Sidebar-module__naTdSG__watchPickRowOn",
  "watchPickSym": "Sidebar-module__naTdSG__watchPickSym",
  "watchPicker": "Sidebar-module__naTdSG__watchPicker",
  "watchPickerBand": "Sidebar-module__naTdSG__watchPickerBand",
  "watchPickerBandMeta": "Sidebar-module__naTdSG__watchPickerBandMeta",
  "watchPickerBandTitle": "Sidebar-module__naTdSG__watchPickerBandTitle",
  "watchPickerBody": "Sidebar-module__naTdSG__watchPickerBody",
  "watchPickerBrand": "Sidebar-module__naTdSG__watchPickerBrand",
  "watchPickerBrandText": "Sidebar-module__naTdSG__watchPickerBrandText",
  "watchPickerFoot": "Sidebar-module__naTdSG__watchPickerFoot",
  "watchPickerHead": "Sidebar-module__naTdSG__watchPickerHead",
  "watchPickerList": "Sidebar-module__naTdSG__watchPickerList",
  "watchPickerName": "Sidebar-module__naTdSG__watchPickerName",
  "watchPickerPad": "Sidebar-module__naTdSG__watchPickerPad",
  "watchPickerSearch": "Sidebar-module__naTdSG__watchPickerSearch",
  "watchPickerSection": "Sidebar-module__naTdSG__watchPickerSection",
  "watchPickerStatus": "Sidebar-module__naTdSG__watchPickerStatus",
  "watchPickerTag": "Sidebar-module__naTdSG__watchPickerTag",
  "watchPip": "Sidebar-module__naTdSG__watchPip",
  "watchPipLive": "Sidebar-module__naTdSG__watchPipLive",
  "watchPipMark": "Sidebar-module__naTdSG__watchPipMark",
  "watchRow": "Sidebar-module__naTdSG__watchRow",
  "watchRowChg": "Sidebar-module__naTdSG__watchRowChg",
  "watchRowOn": "Sidebar-module__naTdSG__watchRowOn",
  "watchSearch": "Sidebar-module__naTdSG__watchSearch",
  "watchSearchClear": "Sidebar-module__naTdSG__watchSearchClear",
  "watchSearchMark": "Sidebar-module__naTdSG__watchSearchMark",
  "watchSearchSr": "Sidebar-module__naTdSG__watchSearchSr",
  "watchSearchWell": "Sidebar-module__naTdSG__watchSearchWell",
  "watchStack": "Sidebar-module__naTdSG__watchStack",
  "watchStrip": "Sidebar-module__naTdSG__watchStrip",
  "watchStripPinsOnly": "Sidebar-module__naTdSG__watchStripPinsOnly",
  "watchSym": "Sidebar-module__naTdSG__watchSym",
  "watchUp": "Sidebar-module__naTdSG__watchUp",
  "widgetBand": "Sidebar-module__naTdSG__widgetBand",
  "widgetBandLabel": "Sidebar-module__naTdSG__widgetBandLabel",
  "widgetBandMeta": "Sidebar-module__naTdSG__widgetBandMeta",
  "widgetBody": "Sidebar-module__naTdSG__widgetBody",
  "widgetCard": "Sidebar-module__naTdSG__widgetCard",
  "widgetCardLead": "Sidebar-module__naTdSG__widgetCardLead",
  "widgetDown": "Sidebar-module__naTdSG__widgetDown",
  "widgetKey": "Sidebar-module__naTdSG__widgetKey",
  "widgetLockCopy": "Sidebar-module__naTdSG__widgetLockCopy",
  "widgetLockIcon": "Sidebar-module__naTdSG__widgetLockIcon",
  "widgetLocked": "Sidebar-module__naTdSG__widgetLocked",
  "widgetMetric": "Sidebar-module__naTdSG__widgetMetric",
  "widgetMetricHero": "Sidebar-module__naTdSG__widgetMetricHero",
  "widgetPicker": "Sidebar-module__naTdSG__widgetPicker",
  "widgetPickerBrand": "Sidebar-module__naTdSG__widgetPickerBrand",
  "widgetPickerBrandName": "Sidebar-module__naTdSG__widgetPickerBrandName",
  "widgetPickerBrandTag": "Sidebar-module__naTdSG__widgetPickerBrandTag",
  "widgetPickerCheck": "Sidebar-module__naTdSG__widgetPickerCheck",
  "widgetPickerCopy": "Sidebar-module__naTdSG__widgetPickerCopy",
  "widgetPickerDesc": "Sidebar-module__naTdSG__widgetPickerDesc",
  "widgetPickerItem": "Sidebar-module__naTdSG__widgetPickerItem",
  "widgetPickerItemLocked": "Sidebar-module__naTdSG__widgetPickerItemLocked",
  "widgetPickerItemOn": "Sidebar-module__naTdSG__widgetPickerItemOn",
  "widgetPickerLead": "Sidebar-module__naTdSG__widgetPickerLead",
  "widgetPickerList": "Sidebar-module__naTdSG__widgetPickerList",
  "widgetPickerTitle": "Sidebar-module__naTdSG__widgetPickerTitle",
  "widgetPickerUnlock": "Sidebar-module__naTdSG__widgetPickerUnlock",
  "widgetSub": "Sidebar-module__naTdSG__widgetSub",
  "widgetUp": "Sidebar-module__naTdSG__widgetUp",
  "widgetVal": "Sidebar-module__naTdSG__widgetVal",
  "widgetValHero": "Sidebar-module__naTdSG__widgetValHero",
});
